import { postReport } from '../../../../services/api.js';
import { reportFilterFields } from '../../../../utils/reportRequestBody.js';
/**
 * maintenanceApi.js — API functions for the Maintenance Report page.
 *
 * fetchMaintenanceReport — runs the maintenance report query (cloud + on-premise)
 *
 * Filter options are re-exported from alertDetailsApi.js to avoid duplication.
 */

// Re-export shared filter options fetcher

export { fetchFilterOptions } from '../../alert-details/api/alertDetailsApi.js';


// ---------------------------------------------------------------------------
// Fetch Maintenance Report
// ---------------------------------------------------------------------------

/**
 * Runs the maintenanceReport query with all filter fields.
 *
 * Supports both cloud and on-premise variants:
 * - Cloud: includes `is_cloud: true` in the payload
 * - On-premise: includes `campus_guid` in the payload
 *
 * @param {object} opts
 * @param {number} opts.campusId
 * @param {string} [opts.campusGuid]  — campus GUID for on-premise
 * @param {boolean} opts.isCloud       — whether this campus is cloud-based
 * @param {string} opts.username
 * @param {string} opts.startDate      — ISO format (yyyy-mm-dd hh:mm:ss)
 * @param {string} opts.endDate        — ISO format
 * @param {object} opts.filters        — all report-level filter selections
 * @returns {Promise<object>} — { records, overlimit, url, ErrorCode }
 */
export async function fetchMaintenanceReport({ campusId, campusGuid, isCloud, username, startDate, endDate, filters = {} }) {
    const body = {
        rep_type: 'maintenanceReport',
        username: username || '',
        campus_id: campusId,
        start_date: startDate,
        end_date: endDate,
        event_category_filter: '2',
        ...reportFilterFields(filters),
    };

    // Cloud vs on-premise identifier
    if (isCloud) {
        body.is_cloud = true;
    } else {
        body.campus_guid = campusGuid || '';
    }

    const res = await postReport(body, '[maintenanceApi] fetchMaintenanceReport error');
    if (res.ErrorCode) return { ErrorCode: res.ErrorCode };
    const data = res.data;

    return {
        records: data?.records || [],
        overlimit: Boolean(data?.overlimit),
        url: data?.url || '',
    };
}
